import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import Modal from "./Modal";
import Loading from "components/Loader/Spinner";
import CustomSpinner from "components/Loader/CustomSpinner";
import {
  BACKGROUND_WALLET,
  MODAL_CLOSE,
  COMPLETE_TRANSACTION,
  FAILED_TRANSACTION,
} from "src/constants/images";
import { replaceFloatValue } from "utils/replaceFloatValue";
import { WALLET_TYPE } from "src/constants/walletType";

const Loader = ({
  response,
  setIsSuccess,
  totalCost,
  nftCount,
  icxInUSD,
  walletType,
}) => {
  const [timer, setTimer] = useState(90);
  const [successTrigger, setSuccessTrigger] = useState(false);

  useEffect(() => {
    if (response.status === "success") {
      const timeCount = setInterval(() => {
        setTimer(timer - 1);
      }, 1000);

      if (timer === 0) {
        setSuccessTrigger(true);
        setIsSuccess(true);
      }

      return () => clearInterval(timeCount);
    }
  }, [response.status, timer]);

  return (
    <>
      <div className="header">
        <img
          src={BACKGROUND_WALLET.SOURCE}
          alt="background"
          className="background-wallet"
        />
        <h4 className="mb-2">Wallet connected!</h4>
        <p className="text">
          {walletType == WALLET_TYPE.LEDGER
            ? "Ledger is connecting to mint NFT"
            : ""}
          <br />
          Total Price: <strong>{totalCost * nftCount} ICX </strong>
          {/* (${replaceFloatValue(totalCost * nftCount * icxInUSD)}) */}
        </p>
      </div>
      <div className="body loading">
        <CustomSpinner />
      </div>
      <div className="footer">
        {response.status === "success" ? (
          <p className="py-2">
            {`Minting ${nftCount} GangstaBet NFT${nftCount === 1 ? "" : "s"}`}

            <br />
            {`Please wait... ${timer} seconds`}
          </p>
        ) : (
          <p className="py-2">
            {`Minting ${nftCount} NFT(s) for`} {totalCost * nftCount} ICX.
            {/* (${replaceFloatValue(totalCost * nftCount * icxInUSD)})  */}
            <br />
            Please wait..
          </p>
        )}
        <button disabled className="btn btn-outline-secondary close">
          Close
        </button>
      </div>
    </>
  );
};

const Success = ({ onClick, totalCost, nftCount, icxInUSD, walletType }) => {
  return (
    <>
      <span
        onClick={() => onClick()}
        onKeyPress={(e) => e.code == "Enter" && onClick()}
        className="close-modal"
      >
        <img src={MODAL_CLOSE.SOURCE} alt="close" />
      </span>
      <div className="header">
        <h4 className="mb-3">Congratulations!</h4>
        <p className="text">
          You successfully minted {nftCount} new GangstaBet.
          <br />
          Total cost {nftCount * totalCost} ICX.
          {/* (${replaceFloatValue(icxInUSD * nftCount * totalCost)}). */}
        </p>
        <p>Your Transaction is gone through it. Please check your wallet.</p>
      </div>
      <div className="body">
        <img
          src={COMPLETE_TRANSACTION.SOURCE}
          alt="transaction completed"
          className="d-block mx-auto my-3"
        />
        <button
          className="btn btn-outline-primary profile"
          onClick={() => onClick("wallet")}
        >
          Show me
        </button>
      </div>
    </>
  );
};

const Cancel = ({ onClick }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="header">
      <h4 className="mb-2 me-2 ms-md-0">Oh No! Transaction Cancelled</h4>
      <p className="text my-3">Transaction cancelled.</p>
    </div>
    <div className="body">
      <span className="d-block mx-auto my-3 failed-transaction">
        <img
          src={FAILED_TRANSACTION.SOURCE}
          alt="transaction failed"
          className="mb-0"
        />
      </span>
      <button className="btn btn-outline-primary profile" onClick={onClick}>
        Close
      </button>
    </div>
  </>
);

const Error = ({ onClick, message }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="header">
      <h4 className="mb-2 me-2 ms-md-0">Oh no! Transaction failed</h4>
      <p className="text my-3">
        Could not purchase <strong>GangstaBet</strong> due to transaction
        failure, please try again after sometime!
        <br />
        {message}
      </p>
    </div>
    <div className="body">
      <span className="d-block mx-auto my-3 failed-transaction">
        <img
          src={FAILED_TRANSACTION.SOURCE}
          alt="transaction failed"
          className="mb-0"
        />
      </span>
      <button className="btn btn-outline-primary profile" onClick={onClick}>
        Close
      </button>
    </div>
  </>
);

const BuyingModal = ({
  response,
  onClick,
  isVisible,
  nftCount,
  totalCost,
  reloadReservation,
  walletType,
}) => {
  const icxInUSD = useSelector((state) => state.icxPricing.price);

  const [isSuccess, setIsSuccess] = React.useState(false);

  useEffect(() => {
    if (isSuccess) {
      reloadReservation();
    }
  }, [isSuccess]);

  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="buying-modal card px-3 py-4"
    >
      {isSuccess &&
        (response.status === "success" || response.status === "error") ? (
        <Success
          onClick={onClick}
          totalCost={totalCost}
          nftCount={nftCount}
          icxInUSD={icxInUSD}
          walletType={walletType}
        />
      ) : response.status === "cancel" ? (
        <Cancel onClick={onClick} walletType={walletType} />
      ) : response.status === "error" ? (
        <Error onClick={onClick} walletType={walletType} />
      ) : (
        <Loader
          response={response}
          setIsSuccess={setIsSuccess}
          totalCost={totalCost}
          nftCount={nftCount}
          icxInUSD={icxInUSD}
          walletType={walletType}
        />
      )}
    </Modal>
  );
};

export default BuyingModal;
